import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LabTestResult } from '../../lab-test-results';

export const SITE_LAB_RESULTS_STORAGE = new InjectionToken<SiteTestDataStorage>('SiteLabResultsStorageToken');

export interface SiteTestDataStorage {
    getData: Observable<LabTestResult[]>;
}
